// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Image$SmartcutsMacros = require("../Image.bs.js");
var Browser__Debugger$SmartcutsMacros = require("../browser/Browser__Debugger.bs.js");

var LayoutViewport = {};

var $$VisualViewport = {};

var Viewport = {};

var methodName = "Page.getLayoutMetrics";

var Result = {};

var GetLayoutMetrics = {
  methodName: methodName,
  Result: Result
};

function getLayoutMetrics(tabId, extensionId, targetId, param) {
  var params = {};
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName, params);
}

var methodName$1 = "Page.captureScreenshot";

var Params = {};

var Result$1 = {};

var CaptureScreenshot = {
  methodName: methodName$1,
  Params: Params,
  Result: Result$1
};

function captureScreenshot(tabId, extensionId, targetId, format, quality, clip, fromSurface, captureBeyondViewport, param) {
  var tmp = {};
  var tmp$1 = Belt_Option.map(format, Image$SmartcutsMacros.Format.stringify);
  if (tmp$1 !== undefined) {
    tmp.format = Caml_option.valFromOption(tmp$1);
  }
  if (quality !== undefined) {
    tmp.quality = Caml_option.valFromOption(quality);
  }
  if (clip !== undefined) {
    tmp.clip = Caml_option.valFromOption(clip);
  }
  if (fromSurface !== undefined) {
    tmp.fromSurface = Caml_option.valFromOption(fromSurface);
  }
  if (captureBeyondViewport !== undefined) {
    tmp.captureBeyondViewport = Caml_option.valFromOption(captureBeyondViewport);
  }
  var params = tmp;
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$1, params);
}

exports.LayoutViewport = LayoutViewport;
exports.$$VisualViewport = $$VisualViewport;
exports.Viewport = Viewport;
exports.GetLayoutMetrics = GetLayoutMetrics;
exports.getLayoutMetrics = getLayoutMetrics;
exports.CaptureScreenshot = CaptureScreenshot;
exports.captureScreenshot = captureScreenshot;
/* Image-SmartcutsMacros Not a pure module */
